module.exports = __webpack_public_path__ + "img/icon-ghs.15c47ee5.svg";